// src/pages/overview/OverviewLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import { projectMenus } from "../../components/layout/ProjectMenus";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import Forbidden from "../../components/common/ui/Forbidden";

export default function OverviewLayout({ hasPermission }) {
  // 권한 없으면 차단
  // if (!hasPermission) return <Forbidden />;

  const { title, base, sections } = projectMenus.overview;

  return (
    <SidebarLayout title={title} base={base} sections={sections}>
        <Outlet />
    </SidebarLayout>
  );
}


const user = { role: "admin" };
const is_superuser = user.role === "admin";
